module.exports = __webpack_public_path__ + "static/img/in-dl.28b620f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/in-dl.png
// module id = M45b
// module chunks = 1